export enum AngstromTagIdValues {
    Sgp = 'SGP',
    Popular = 'Popular',
}
